//@ts-noCheck
import React, { forwardRef, useState } from 'react';
import Box from '@/components/UI/box/Box';
import DatePickerTooltip from '../datePickerTooltip/DatePickerTooltip';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import LockDays from '../futureDays/FutureDays';
import { getPropByString } from '@/helpers/props';
import styles from './DatePickerDays.module.scss';
const DayDatePicker = forwardRef(({
  item,
  isDayDisabled,
  tooltipContent,
  formatPrice,
  onDayClick,
  checkOutDate,
  todayDate,
  nextRangeDays,
  isFull,
  classNameList,
  leaveRef,
  hoverRef
}, ref) => {
  const [isHoverd, setIsHovered] = useState(false);
  const getClassNames = () => {
    const classNames = new Set([...classNameList]);
    if (isFull) {
      classNames.add('day-tag-isFull');
      classNames.add('day-label-isFull');
    } else {
      classNames.add('day-tag-notFull');
      classNames.add('day-label-notFull');
    }
    const mappedClassNames = ([...classNames] || []).map(className => styles[className] || className).join(' ');
    return mappedClassNames;
  };
  return <Box className={getClassNames()} ref={ref} onClick={() => onDayClick && onDayClick(item)} onMouseEnter={() => {
    hoverRef?.current(item);
    setIsHovered(true);
  }} onMouseLeave={() => {
    leaveRef?.current();
    setIsHovered(false);
  }}>
        {tooltipContent?.content && <DatePickerTooltip type={tooltipContent.type} content={tooltipContent.content} show={isHoverd} />}

        {item.ts <= nextRangeDays.ts ? <>
            <Box className={styles[`day-label`]}>
              <Box className={`${styles['day-label-dates']} ${isFull ? styles['day-label-full-height'] : ''}`}>
                <Box className={`${styles['date-picker-day-wrapper']} ${isFull ? styles['datepicker-wraper-full-height'] : ''}`}>
                  {isFull && item.is_instant && !item?.is_day_disabled && <Box className={styles[`date-picker-instant-icon`]}>
                      <Icon name="flash-Filled" type="inherit" size="small" />
                    </Box>}
                  <Typography variant="title" className={styles['day']}>
                    {item.day}
                  </Typography>
                </Box>
                {isFull && !!getPropByString(item, 'raw_price') && <>
                    {Boolean(item.specialDiscount) && <Box className={styles['calendar-offer-price']}>
                        {formatPrice(item.raw_price)}
                      </Box>}
                    <Box className={`${styles['price']} ${item.ts === (checkOutDate || {}).ts ? styles['hide-price'] : ''}`}>
                      {formatPrice(item.specialDiscount ? item.specialDiscount : item.raw_price)}
                    </Box>
                  </>}
              </Box>
            </Box>
          </> : <LockDays isFull={isFull} day={item.day} />}
      </Box>;
});
DayDatePicker.displayName = 'DayDatePicker';
export default React.memo(DayDatePicker, () => true);